"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteOption = exports.ContextualStyleOption = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ContextualStyleOption = function (onClick) { return ({
    value: "style",
    hint: "section style",
    icon: react_1.default.createElement(icons_1.Styles, null),
    onClick: onClick,
}); };
exports.ContextualStyleOption = ContextualStyleOption;
var DeleteOption = function (onClick) { return ({
    value: "delete",
    hint: "delete",
    icon: react_1.default.createElement(icons_1.Delete, null),
    onClick: onClick,
}); };
exports.DeleteOption = DeleteOption;
